import Image from '@react/shared/components/Image';
import { getIcon } from '@sly/icons/dynamic';
import cx from 'classnames';
import { assetPath } from 'sly/lib/path';
import { Heading } from 'sly/system';

import { GetListWithIcons } from '../../HubPage/HubPage.types';

const iconArr = [
  'vectors/home/advisor.svg',
  'vectors/home/smart-search.svg',
  'vectors/home/freedom-to-explore.svg',
];

const ThreeColumnValue = ({
  getListWithIcons,
}: {
  getListWithIcons: GetListWithIcons[];
}) => {
  return (
    <>
      {getListWithIcons?.length > 0 && (
        <div
          className={cx(
            'my-xxl mx-m flex justify-center',
            'flex-col items-baseline md:my-xxxl md:mx-l',
            'items-start lg:my-xxxl lg:mx-auto lg:w-[64.5rem]'
          )}
          data-tp-id='gen-Flex-be591a01-c1b1-4dfb-af43-45f39f3d8164'
        >
          <Heading
            as='h2'
            className='!font-t-xl lg:!font-t-l m-auto mb-xxl text-slate-base'
            data-tp-id='gen-Heading-bd314331-f5ae-40c3-a91b-c22c0c59f362'
          >
            {getListWithIcons?.[0]?.titleThreeColumnValue}
          </Heading>
          <div
            className='flex flex-col md:flex-row'
            data-tp-id='gen-Flex-61e65a46-ff8e-430a-b435-dfc7f049496d'
          >
            {getListWithIcons?.[0]?.IconList?.map((item, index) => {
              const Icon = getIcon(item.icon);
              const icon = Icon ? (
                <Icon size='xl' />
              ) : (
                <div className='relative mr-l mb-m aspect-1 h-[52px] w-[60px]'>
                  <Image
                    src={assetPath(iconArr[index])}
                    data-tp-id='gen-Image-85442af3-d5f0-4115-bf85-0d26a82e1e7c'
                    alt='list-icon'
                    layout='fill'
                    objectFit='contain'
                  />
                </div>
              );
              return (
                <div
                  className={cx(
                    'flex w-full flex-col text-center',
                    getListWithIcons?.[0]?.IconList?.length - 1 !== index &&
                      'mb-xxl md:mr-l',
                    'md:mb-0 md:items-baseline'
                  )}
                  key={item?.id}
                  data-tp-id='gen-Flex-109a331c-9d0c-4afb-bb24-d6d3a59d7555'
                >
                  <div className='mx-auto'>{icon}</div>
                  <div
                    className='marketing-how-it-works-block-tile font-b-l'
                    dangerouslySetInnerHTML={{
                      __html: item?.value,
                    }}
                    data-tp-id='gen-div-47b53c5b-e37f-43b7-8692-f6cfe3644d65'
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default ThreeColumnValue;
